/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import Switch from 'react-switch'
import { Col, Row, FormGroup, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState, sizeOptions } from './constants'
import BSInfantCerealProduct from 'models/BSInfantCerealProduct'

const BSInfantCerealPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()

  const { setSelect, setSwitch, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const { category, subCategory, Size, Organic } = current

      setPackaging({
        category,
        subCategory,
        Size,
        Organic,
      })
    } else if (!updating) {
      setCurrent(BSInfantCerealProduct)
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={sizeOptions}
            name="Size"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Size'}
            onChange={([selected]) => {
              setSelect(selected, 'Size')
              return selected
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Please Select a size.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
      </Col>
      <Col xs={4}></Col>
      <Col xs={4}>
        <FormGroup>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.Organic}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

export default BSInfantCerealPackage
